import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
	providedIn: 'root'
})
/**
 * 즐겨 찾기 서비스
 */
export class FavoriteService {
	protected _subjects: Record<string, BehaviorSubject<Array<string | number>>> = {};

	/**
	 * 즐겨찾기 항목 반환
	 * @param id
	 * @param separator
	 */
	get(id: string, separator = '|') {
		const keys = localStorage.getItem(id);
		return keys && keys.length ? keys.split(separator) : [];
	}

	/**
	 * 비동기 즐겨 찾기 항목 반환
	 * @param id
	 * @param separator
	 */
	get$(id: string, separator = '|') {
		const keys = this.get(id, separator);

		const {_subjects} = this;
		let subject = _subjects[id];
		if (!subject) {
			subject = new BehaviorSubject(keys.length ? keys : null);
			_subjects[id] = subject;
		}
		return subject;
	}

	/**
	 * 즐겨찾기 항목 설정
	 * @param id
	 * @param keys
	 * @param separator
	 */
	set(id: string, keys: Array<string | number>, separator = '|') {
		if (keys.length) {
			localStorage.setItem(id, keys.join(separator));
		} else {
			localStorage.removeItem(id);
		}

		const subject = this._subjects[id];
		if (subject) {
			subject.next(keys.length ? keys : null);
		}
	}
}
